import { Component, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SettingsBase } from 'app/_models/admin/settings/settings.base';
import { AdminSettingsService } from 'app/_services/admin/admin-settings.service';

@Component({
  selector: 'app-admin-settings-ecpa',
  templateUrl: './admin-settings-ecpa.component.html',
  styleUrl: './admin-settings-ecpa.component.scss'
})
export class AdminSettingsEcpaComponent {
  settings: SettingsBase;
  focusInput = new EventEmitter<boolean>();

  constructor(
    public adminSettingsService: AdminSettingsService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.data
      .subscribe((data: any) => {
        this.settings = data.settings;
        setTimeout(() => {
          this.focusInput.emit(true);
        }, 0);
      });
  }

  changeUrlStart(urlStartNew: string) {
    const urlStartOld = this.adminSettingsService.getAdminSetting(this.settings, 'UrlStart').Value;
    this.adminSettingsService.getAdminSetting(this.settings, 'UrlStart').Value = urlStartNew;
    this.adminSettingsService.getAdminSetting(this.settings, 'WebApiURL').Value = this.adminSettingsService.getAdminSetting(this.settings, 'WebApiURL').Value.replace(urlStartOld, urlStartNew);
    this.adminSettingsService.getAdminSetting(this.settings, 'WebServiceURL').Value = this.adminSettingsService.getAdminSetting(this.settings, 'WebServiceURL').Value.replace(urlStartOld, urlStartNew);
  }

  advancedChanged(value: any) {
    setTimeout(() => {
          this.focusInput.emit(true);
        }, 100);
  }

}
